module.exports = __webpack_public_path__ + "img/featured-yahoo.b62ef2bf.jpg";